module.exports = __webpack_public_path__ + "img/dcmm_29.32558b10.png";